var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/hooks/config.tsx
import { useContext } from "react";

// src/contexts/config.ts
import { createContext } from "react";
var VimAppConfig = createContext(void 0);

// src/hooks/config.tsx
function useConfig() {
  return useContext(VimAppConfig);
}

// src/hooks/ehr-action.tsx
import { useCallback as useCallback2 } from "react";

// src/events.ts
var IncomingEventFromApp = /* @__PURE__ */ ((IncomingEventFromApp2) => {
  IncomingEventFromApp2["PatientInContext"] = "PatientInContext";
  IncomingEventFromApp2["PatientOutOfContext"] = "PatientOutOfContext";
  IncomingEventFromApp2["EncounterStart"] = "EncounterStart";
  IncomingEventFromApp2["EncounterUpdated"] = "EncounterUpdated";
  IncomingEventFromApp2["EncounterExit"] = "EncounterExit";
  IncomingEventFromApp2["ReferralViewed"] = "ReferralViewed";
  IncomingEventFromApp2["ReferralClosed"] = "ReferralClosed";
  IncomingEventFromApp2["AccessTokenChanged"] = "AccessTokenChanged";
  IncomingEventFromApp2["Init"] = "Init";
  return IncomingEventFromApp2;
})(IncomingEventFromApp || {});
var OutgoingEventToApp = /* @__PURE__ */ ((OutgoingEventToApp2) => {
  OutgoingEventToApp2["SelectAppInHub"] = "SelectAppInHub";
  OutgoingEventToApp2["ModifyWidget"] = "ModifyWidget";
  OutgoingEventToApp2["Writeback"] = "Writeback";
  OutgoingEventToApp2["RunAction"] = "RunAction";
  return OutgoingEventToApp2;
})(OutgoingEventToApp || {});
var HubOutgoingEvents = /* @__PURE__ */ ((HubOutgoingEvents2) => {
  HubOutgoingEvents2["SelectAppInHub"] = "SelectAppInHub";
  HubOutgoingEvents2["ModifyWidget"] = "ModifyWidget";
  HubOutgoingEvents2["RunAction"] = "RunAction";
  return HubOutgoingEvents2;
})(HubOutgoingEvents || {});

// src/hooks/old-comm.tsx
import { sendSyncEventToVimConnectHubApp } from "@getvim/utils-vim-connect-communication";
import { useCallback, useRef, useState } from "react";
function useOldComm(eventName) {
  const { applicationId } = useConfig();
  const [response, setResponse] = useState({
    data: void 0,
    loading: false,
    error: void 0
  });
  const latestSyncEventPromiseRef = useRef();
  const request = useCallback(async (params) => {
    setResponse({ data: void 0, loading: true, error: void 0 });
    const syncEventPromise = sendSyncEventToVimConnectHubApp(applicationId, eventName, params);
    latestSyncEventPromiseRef.current = syncEventPromise;
    try {
      const { data, error } = await syncEventPromise;
      if (error) {
        throw error;
      }
      if (latestSyncEventPromiseRef.current === syncEventPromise) {
        setResponse({ data, loading: false, error: void 0 });
      }
      return data;
    } catch (error) {
      if (latestSyncEventPromiseRef.current === syncEventPromise) {
        setResponse({ data: void 0, loading: false, error });
      }
      throw error;
    }
  }, [eventName, applicationId]);
  return [request, response];
}

// src/hooks/ehr-action.tsx
function useEhrAction(type) {
  const [originalRequest, originalResponse] = useOldComm("RunAction" /* RunAction */);
  const request = useCallback2((payload) => {
    return originalRequest({
      type,
      payload
    });
  }, [type]);
  return [request, originalResponse];
}

// src/hooks/ehr-state.tsx
import { useContext as useContext2 } from "react";

// src/contexts/ehr-state.ts
import { createContext as createContext2 } from "react";
var VimEhrState = createContext2({});

// src/hooks/ehr-state.tsx
function useEhrState() {
  return useContext2(VimEhrState);
}

// src/hooks/ehr-writeback.tsx
import { useCallback as useCallback3 } from "react";
function useEhrWriteback(type, options) {
  const [originalRequest, originalResponse] = useOldComm("Writeback" /* Writeback */);
  const request = useCallback3((payload) => {
    return originalRequest({
      writeBack: type,
      data: payload,
      config: options
    });
  }, [type, options]);
  return [request, originalResponse];
}
var WritebackType = /* @__PURE__ */ ((WritebackType2) => {
  WritebackType2["updateProblemList"] = "updateProblemList";
  WritebackType2["updateReferral"] = "updateReferral";
  WritebackType2["updateEncounter"] = "updateEncounter";
  return WritebackType2;
})(WritebackType || {});

// src/hooks/hub-controls.tsx
function useHubControls() {
  const [select] = useOldComm("SelectAppInHub" /* SelectAppInHub */);
  const [modify] = useOldComm("ModifyWidget" /* ModifyWidget */);
  return { select, modify };
}

// src/hooks/widget.tsx
function useWidget() {
  return {
    active: true,
    loading: false,
    inject: (config) => {
    },
    modify: () => {
    },
    remove: () => {
    },
    send: (data) => {
    },
    subscribe: (callback) => {
    }
  };
}

// src/hooks/send-hub-events.tsx
import { useCallback as useCallback4 } from "react";
import { sendSyncEventToVimConnectHubApp as sendSyncEventToVimConnectHubApp2 } from "@getvim/utils-vim-connect-communication";
function useSendHubEvents(widgetId) {
  const sendEventToHub = useCallback4((outgoingEvent, payload) => sendSyncEventToVimConnectHubApp2(widgetId, outgoingEvent, payload), [widgetId]);
  return { sendEventToHub };
}

// src/hooks/use-scroll-handler.tsx
import { useEffect, useState as useState2 } from "react";
var useScrollHandler = (onScrollHandle, refScrollElem) => {
  const [isScrolled, setScrolled] = useState2(false);
  useEffect(() => {
    if (isScrolled) {
      onScrollHandle();
    }
  }, [isScrolled]);
  useEffect(() => {
    refScrollElem == null ? void 0 : refScrollElem.addEventListener("scroll", () => {
      setScrolled(true);
    });
  }, [refScrollElem]);
};

// src/provider.tsx
import { logger as logger2 } from "@getvim/vim-connect-logger";
import { registerVimConnectUIWidget } from "@getvim/utils-vim-connect-communication";
import React, { useEffect as useEffect2, useState as useState3 } from "react";

// src/channel.ts
var Channel = class {
  constructor() {
    this.callbacks = /* @__PURE__ */ new Set();
  }
  subscribe(callback) {
    this.callbacks.add(callback);
  }
  unsubscribe(callback) {
    this.callbacks.delete(callback);
  }
  publish(data) {
    this.latest = data;
    this.callbacks.forEach((callback) => callback(data));
  }
};

// src/clientLogger.ts
import { logger } from "@getvim/vim-connect-logger";
var vimConnectClientLogger = logger;

// src/provider.tsx
var ProviderLogger = logger2.scope("Vim Provider");
var VimProvider = ({
  applicationId,
  onAccessTokenChanged,
  children
}) => {
  const [config, setConfig] = useState3();
  const [accessToken, setAccessToken] = useState3();
  const [accessTokenChannel] = useState3(new Channel());
  const [ehrState, setEhrState] = useState3();
  const [patient, setPatient] = useState3();
  const [encounter, setEncounter] = useState3();
  const [referral, setReferral] = useState3();
  const [requestNpi, setRequestNpi] = useState3();
  useEffect2(() => {
    const handleEvents = (payload) => {
      const { event, data } = payload;
      switch (event) {
        case "PatientInContext" /* PatientInContext */: {
          setEhrState((prev) => __spreadProps(__spreadValues({}, prev), { patient: data }));
          break;
        }
        case "PatientOutOfContext" /* PatientOutOfContext */: {
          setEhrState((prev) => __spreadProps(__spreadValues({}, prev), { patient: void 0 }));
          break;
        }
        case "EncounterStart" /* EncounterStart */: {
          setEhrState((prev) => __spreadProps(__spreadValues({}, prev), {
            encounter: data
          }));
          break;
        }
        case "EncounterUpdated" /* EncounterUpdated */: {
          setEhrState((prev) => __spreadProps(__spreadValues({}, prev), { encounter: data }));
          break;
        }
        case "EncounterExit" /* EncounterExit */: {
          setEhrState((prev) => __spreadProps(__spreadValues({}, prev), { encounter: void 0 }));
          break;
        }
        case "ReferralViewed" /* ReferralViewed */: {
          setEhrState((prev) => __spreadProps(__spreadValues({}, prev), {
            referral: data
          }));
          break;
        }
        case "ReferralClosed" /* ReferralClosed */: {
          setEhrState((prev) => __spreadProps(__spreadValues({}, prev), { referral: void 0 }));
          break;
        }
        case "AccessTokenChanged" /* AccessTokenChanged */: {
          onAccessTokenChanged == null ? void 0 : onAccessTokenChanged(data);
          setAccessToken(data);
          break;
        }
        case "Init" /* Init */: {
          setConfig(__spreadProps(__spreadValues({}, data), { applicationId }));
          break;
        }
      }
    };
    registerVimConnectUIWidget(applicationId, handleEvents);
  }, [onAccessTokenChanged, applicationId]);
  useEffect2(() => {
    var _a, _b, _c, _d, _e, _f, _g;
    if (config) {
      vimConnectClientLogger.setMetadata({
        deviceId: (_a = config.workspaceConfig) == null ? void 0 : _a.deviceId,
        windowId: (_c = (_b = config.workspaceConfig) == null ? void 0 : _b.activeWindow) == null ? void 0 : _c.id,
        version: (_d = config.workspaceConfig) == null ? void 0 : _d.version,
        adapterName: (_e = config.organizationConfig) == null ? void 0 : _e.ehrSystem,
        organizationId: (_f = config.organizationConfig) == null ? void 0 : _f.id,
        organization_name: (_g = config.organizationConfig) == null ? void 0 : _g.name
      });
    }
  }, [config]);
  useEffect2(() => {
    setConfig((oldConfig) => oldConfig && __spreadProps(__spreadValues({}, oldConfig), { applicationId }));
  }, [applicationId]);
  useEffect2(() => {
    if (ehrState) {
      ehrState.hasOwnProperty("patient") ? setPatient(ehrState.patient) : null;
      ehrState.hasOwnProperty("encounter") ? setEncounter(ehrState.encounter) : null;
      ehrState.hasOwnProperty("referral") ? setReferral(ehrState.referral) : null;
    }
  }, [ehrState]);
  return applicationId && config && !!accessToken ? /* @__PURE__ */ React.createElement(VimAppConfig.Provider, {
    value: config
  }, /* @__PURE__ */ React.createElement(VimEhrState.Provider, {
    value: {
      patient,
      encounter,
      referral,
      requestNpi
    }
  }, children)) : null;
};

// src/types/analytics.ts
var BaseWidgetAnalyticsEventTypes = /* @__PURE__ */ ((BaseWidgetAnalyticsEventTypes2) => {
  BaseWidgetAnalyticsEventTypes2["appScrollStart"] = "app_scroll_start";
  BaseWidgetAnalyticsEventTypes2["appHoverStart"] = "app_hover_start";
  BaseWidgetAnalyticsEventTypes2["appHoverEnd"] = "app_hover_end";
  BaseWidgetAnalyticsEventTypes2["itemHover"] = "item_hover";
  return BaseWidgetAnalyticsEventTypes2;
})(BaseWidgetAnalyticsEventTypes || {});

// src/headers.ts
var HEADERS = {
  REQUEST_NPI: "x-vim-request-npi"
};

// src/utils/typeFormatter.ts
import dayjs from "dayjs";
var formatDateString = (date) => dayjs(date).format("MM/DD/YYYY");
var capitalizeLeadingLetter = (text) => text.toLowerCase().split(". ").map((sentence) => {
  const trimmed = sentence.trim();
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
}).join(". ").trim();
var upperCaseOnlyFirstLetter = (text) => text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();

// src/utils/undoStateCalc.ts
var UndoButtonState = /* @__PURE__ */ ((UndoButtonState2) => {
  UndoButtonState2["NOT_SUPPORTED"] = "NOT_SUPPORTED";
  UndoButtonState2["SUPPORTED_DISABLED"] = "SUPPORTED_DISABLED";
  UndoButtonState2["SUPPORTED_DISABLED_TIMEOUT"] = "SUPPORTED_DISABLED_TIMEOUT";
  UndoButtonState2["SUPPORTED_ENABLED"] = "SUPPORTED_ENABLED";
  UndoButtonState2["OUT_OF_EXAM"] = "OUT_OF_EXAM";
  return UndoButtonState2;
})(UndoButtonState || {});
var calcUndoConfig = (sources, sourcesNotSupportedUndo) => {
  const sourcesMap = {};
  sources.forEach((source) => {
    sourcesMap[source] = sourcesNotSupportedUndo.includes(source);
  });
  const isAllSourcesNotSupportUndo = Object.values(sourcesMap).every((value) => value === true);
  const isAllSourcesSupportUndo = Object.values(sourcesMap).every((value) => value === false);
  const undoConfig = {};
  Object.keys(sourcesMap).forEach((source) => {
    undoConfig[alignSourceNameToNamespace(source)] = getStateForSource(sourcesMap[source], isAllSourcesNotSupportUndo, isAllSourcesSupportUndo);
  });
  return undoConfig;
};
function getStateForSource(isSourceNotSupportUndo, isAllSourcesNotSupportUndo, isAllSourcesSupportUndo) {
  if (isAllSourcesNotSupportUndo) {
    return "NOT_SUPPORTED" /* NOT_SUPPORTED */;
  }
  if (isAllSourcesSupportUndo) {
    return "SUPPORTED_ENABLED" /* SUPPORTED_ENABLED */;
  }
  return isSourceNotSupportUndo ? "SUPPORTED_DISABLED" /* SUPPORTED_DISABLED */ : "SUPPORTED_ENABLED" /* SUPPORTED_ENABLED */;
}
function alignSourceNameToNamespace(source) {
  if (source === "blue_cross_blue_shield_fl") {
    return "florida";
  }
  if (source === "united_health_care") {
    return "uhc";
  }
  return source;
}
export {
  BaseWidgetAnalyticsEventTypes,
  HEADERS,
  HubOutgoingEvents,
  IncomingEventFromApp,
  OutgoingEventToApp,
  ProviderLogger,
  UndoButtonState,
  VimAppConfig,
  VimEhrState,
  VimProvider,
  WritebackType,
  calcUndoConfig,
  capitalizeLeadingLetter,
  formatDateString,
  upperCaseOnlyFirstLetter,
  useConfig,
  useEhrAction,
  useEhrState,
  useEhrWriteback,
  useHubControls,
  useOldComm,
  useScrollHandler,
  useSendHubEvents,
  useWidget,
  vimConnectClientLogger
};
//# sourceMappingURL=index.js.map
